<template>
  <div id="newsInformation">
    <div class="banner container-fuild text-center" data-i18n="home_news">新闻中心</div>
    <div class="container">
      <div class="nav container text-center">
        <a
          v-for="(tab, index) in items"
          :key="index"
          :class="{ active: currentTab === tab.id }"
          @click="switchTab(tab.id)"
        >
          {{ tab.name[lang] || tab.name }}
        </a>
      </div>
      <div v-if="loading" class="text-center loading-spinner">
        <i class="glyphicon glyphicon-refresh spinning"></i>
      </div>
      <ul v-else class="news-container container-fuild">
        <li
          v-for="(item, index) in productNews"
          :key="item.id"
          class="wow fadeIn"
          @click="goToDetail(item.id)"
        >

          <div class="content">
            <p>{{ item.name[lang] || item.item }}</p>
            <p>{{ item.introduce[lang] || item.introduce }}</p>
<!--            <img class="news-image" src="../assets/img/banner2.jpg" alt="1" />-->
          </div>
          <div class="time">
            <p>{{ item.newsDate.substring(5, 10) }}</p>
            <span>{{ item.newsDate.substring(0, 4) }}</span>
          </div>
          <div class="circle">
            <img src="../assets/img/circle.png" />
            <i class="line center-block"></i>
          </div>
        </li>
      </ul>
      <div class="contaianer-fuild text-center more">
        <i class="glyphicon glyphicon-th"></i>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import { websiteUrl, fileUrl } from "../../url.js";
// 引入翻译变量
import { sharedState } from "../assets/js/languages/fanyi";
import { translatePage } from "../assets/js/languages/change_language";
import { WOW } from "wowjs";

export default {
  name: "newsInformation",
  data() {
    return {
      loading: false,
      items: [],
      currentTab: this.id, // 默认显示公司新闻
      productNews: [],
    };
  },

  mounted() {
    this.getnewstlist();
    var wow = new WOW();
    wow.init();
    translatePage();
  },
  // 语言变量 计算属性
  //切换分类
  computed: {
    filterednews() {
      return this.newsList.filter((item) => item.id === this.currentTab);
    },
    lang() {
      return sharedState.lang;
    },
  },
  methods: {
    //添加加载状态
    async switchTab(tabId) {
      this.loading = true;
      this.currentTab = tabId;
      try {
        await this.getnews(tabId);
      } catch (error) {
        console.error("切换标签失败:", error);
      } finally {
        this.loading = false;
      }
    },

    //根据id获取tabs数据
    async getnewstlist() {
      //缓存
      const cache = localStorage.getItem("newstlistData");
      if (cache) {
        this.items = JSON.parse(cache);
      }
      try {
        const response = await axios.get(
          `${websiteUrl}/mes-official-website-manage/newsClass/list`
        );
        const data = response.data.rows;
        console.log(data[0].name, "123");

        for (let index = 0; index < data.length; index++) {
          if (typeof data[index].name === "string") {
            data[index].name = JSON.parse(data[index].name);
          }
        }
        this.items = data;
        if (this.items.length > 0) {
          let i = this.index || 0;
          console.log(i);
          console.log(this.items);
          this.activeTabId = this.items[i].id;
          this.getnews(this.items[i].id);
        }
        localStorage.setItem("newstlistData", JSON.stringify(this.items));
        if (this.items.length > 0 && !this.currentTab) {
          this.switchTab(this.items[0].id);
        }
      } catch (error) {
        console.error("获取数据失败:", error);
      }
    },
    async getnews(id) {
      console.log(id);
      const cache = localStorage.getItem("newsData");
      if (cache) {
        this.productNews = JSON.parse(cache);

        console.log(this.productNews);
      }
      try {
        const response = await axios.get(
          `${websiteUrl}/mes-official-website-manage/newsDetails/list?belongClass=${id}`
        );
        const data = response.data.rows;
        for (let index = 0; index < data.length; index++) {
          if (typeof data[index].name === "string") {
            data[index].name = JSON.parse(data[index].name);
            data[index].introduce = JSON.parse(data[index].introduce);
            data[index].content = JSON.parse(
              data[index].content.replaceAll("${baseUrl}", fileUrl)
            );
            data[index].image = fileUrl + data[index].image;
          }
        }
        this.productNews = response.data.rows;
        this.productNews.sort((a, b) => new Date(b.newsDate) - new Date(a.newsDate));
        console.log(this.productNews), "huoqu---";
        localStorage.setItem("newsData", JSON.stringify(this.productNews));
      } catch (error) {
        console.error("获取数据失败:", error);
      }
    },
    goToDetail(id) {
      // 使用命名路由+params方式
      console.log(id);
      this.$router.push({
        name: "News",
        params: { id },
        // query: { from: "news-list" }, // 可添加额外查询参数
      });
    },
  },
};
</script>
<style scoped>
.banner {
  margin-top: 62px;
  color: #fff;
  font-size: 30px;
  height: 400px;
  line-height: 400px;
  background-image: url("../assets/img/banner_news.jpg");
  background-repeat: no-repeat;
  background-size: cover;
  background-attachment: scroll;
  background-position: center center;
}
.nav {
  margin: 20px 0;
}
.nav > a {
  display: inline-block;
  text-decoration: none;
  width: 120px;
  height: 45px;
  line-height: 45px;
  color: #333;
  border: 1px solid #333;
}
.nav > a.active {
  color: #003987;
  border-color: #003987;
}
.nav > a:hover {
  color: #003987;
  border-color: #003987;
}
.news-container {
  position: relative;
  overflow: hidden;
  margin-bottom: 0;
}
.news-container > li {
  width: 55.6%;
  height: 175px;
  float: left;
  color: #333;
  text-align: right;
  border-left: 1px solid transparent;
  border-right: 1px solid transparent;
}
.news-container > li:hover {
  color: #003987;
  border: 1px solid #003987;
  cursor: pointer;
}
.news-container > li:nth-of-type(2n) {
  float: right;
  text-align: left;
}
/* 图片基础样式 */
.news-container li img {
   /* 基础样式 */
   width: 90%;
  height: 180px;
  object-fit: cover;
  border-radius: 8px;
  transition: all 0.4s cubic-bezier(0.22, 0.61, 0.36, 1);

  /* 视觉增强 */
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  border: 1px solid rgba(0, 57, 135, 0.1);
  filter: brightness(0.98) contrast(1.05);

  /* 加载过渡 */
  opacity: 0;
  animation: fadeIn 0.6s ease-out forwards;
}
/* 悬停效果 */
.news-container > li:hover .news-image {
  transform: scale(1.03);
  box-shadow: 0 8px 24px rgba(0, 57, 135, 0.15);
  filter: brightness(1.02) contrast(1.1);
}
/* 加载动画 */
/* @keyframes fadeIn {
  from { opacity: 0; transform: translateY(8px); }
  to { opacity: 1; transform: translateY(0); }
} */
/* 备用图样式（当图片加载失败时） */
.news-image:before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(135deg, #f5f7fa 0%, #e4e8eb 100%);
  border-radius: inherit;
}

.news-image:after {
  content: attr(alt);
  position: absolute;
  bottom: 10px;
  left: 10px;
  right: 10px;
  padding: 8px;
  background: rgba(0, 0, 0, 0.6);
  color: white;
  font-size: 12px;
  border-radius: 4px;
  text-align: center;
  opacity: 0;
  transition: opacity 0.3s;
}

.news-image:hover:after {
  opacity: 1;
}
/* 左侧新闻项图片 */
.news-container > li:nth-of-type(odd) img {
  transform-origin: right center;
  margin-left: auto; /* 保持右对齐 */
}

/* 右侧新闻项图片 */
.news-container > li:nth-of-type(even) img {
  transform-origin: left center;
  margin-right: auto; /* 保持左对齐 */
}

/* 悬停效果 */
.news-container > li:hover img {
  transform: scale(1.03);
  box-shadow: 0 6px 16px rgba(0, 57, 135, 0.15);
  filter: brightness(1) contrast(1.1);
}
.news-container > li > .content {
  width: 60%;
  float: left;
  padding: 20px 0;
}
.news-container > li > .time {
  width: 20%;
  float: left;
  padding: 10px 0;
  position: relative;
  z-index: 2; /* 确保时间显示在图片上方 */
}
.news-container > li > .time > p {
  font-size: 30px;
  margin: 5px 0;
}
.news-container > li > .circle {
  width: 20%;
  height: 100%;
  float: left;
  position: relative;
}
.news-container > li > .circle > img {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  width: 20px;
  height: 20px;
}
.news-container > li > .circle > i {
  display: block;
  width: 1px;
  height: 100%;
  background: #707070;
}
.news-container > li:nth-of-type(2n) > .content {
  float: right;
}
.news-container > li:nth-of-type(2n) > .time {
  float: right;
}
.news-container > li:nth-of-type(2n) > .circle {
  float: right;
}
.news-container > li:nth-of-type(1) > .circle > i {
  height: 50%;
  position: absolute;
  top: 50%;
  left: 50%;
}
.more {
  font-size: 25px;
  color: #707070;
}
.more > i {
  cursor: pointer;
}
@media screen and (max-width: 767px) {
  .news-container > li {
    width: 100%;
  }
  .news-container > li > .content {
    width: 70%;
    text-align: left;
    float: right;
  }
  .news-container > li > .time {
    width: 30%;
    text-align: left;
    float: right;
  }
  .news-container > li > .circle {
    display: none;
  }
  .news-container li img {
    height: 140px;
    margin-bottom: 15px;
  }

  /* 移动端取消左右差异 */
  .news-container > li:nth-of-type(n) img {
    transform-origin: center;
    margin: 0 auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/NewsInformation.vue